import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CarbonAvailable from './components/CarbonAvailable';
import CarbonNotAvailable from './components/CarbonNotAvailable';
import './Carbon.scss';

import { AGROFORESTRY_TYPE, REFORESTATION_TYPE } from '../../../../constans/constans';
import { isProjectOver, getLastStageEndTime } from '../../../../utils/helpers';

const Carbon = ({ projectData }) => {
  const { type, carbonApplication, stages, status } = projectData;

  const [carbonAvailableTypes] = useState([REFORESTATION_TYPE, AGROFORESTRY_TYPE]);
  const [lastStageEndTime] = useState(getLastStageEndTime(stages));
  const [isOver] = useState(isProjectOver(status, lastStageEndTime));

  if (isOver && !carbonApplication?.completed) {
    return (
      <div className="carbon__project-finished">
        <FormattedMessage
          id="carbon.projectIsFinished"
          values={{
            p: (...chunks) => <p>{chunks}</p>,
            br: <br />,
          }}
        />
      </div>
    );
  }
  return (
    <div className="carbon">
      {carbonAvailableTypes.includes(type) ? (
        <CarbonAvailable projectData={projectData} />
      ) : (
        <CarbonNotAvailable projectId={projectData.project_id} />
      )}
    </div>
  );
};

export default Carbon;
